// eslint-disable-next-line
import React from 'react';

const LoginFooter = () => null;

export default LoginFooter;
